/**
 * Crawlable internal links from a core product page into the Ova Balance
 * ecosystem. Rendered as normal anchors (TanStack Link emits <a href>), never
 * click-only JavaScript.
 */
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { bundlesContaining } from "@/lib/ovaEcosystem";

export function OvaProtocolLinks({ handle }: { handle: string }) {
  const bundles = bundlesContaining(handle);
  if (bundles.length === 0) return null;

  const heading =
    handle === "ova-balance" ? "Build your Ova Balance protocol" : "Pair it with Ova Balance";

  return (
    <section className="mx-auto mt-16 max-w-6xl px-4 md:px-8" aria-labelledby="ova-protocol-links">
      <h2
        id="ova-protocol-links"
        className="font-display text-2xl font-bold text-brand-deep md:text-3xl"
      >
        {heading}
      </h2>
      <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
        Ova Balance is the core formula. These combinations add complementary nutritional support
        around it.
      </p>
      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {bundles.map((bundle) => (
          <Link
            key={bundle.slug}
            to="/products/$handle"
            params={{ handle: bundle.slug }}
            className="group flex flex-col rounded-3xl border border-border bg-card p-5 transition hover:border-brand/40 hover:shadow-luxury"
          >
            <h3 className="font-display text-lg font-bold text-brand-deep">{bundle.name}</h3>
            <p className="mt-1 text-xs font-medium text-brand">{bundle.supportLine}</p>
            <p className="mt-3 flex-1 text-sm text-muted-foreground">{bundle.cardBlurb}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand">
              {bundle.cta}
              <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
      <p className="mt-4 text-sm text-muted-foreground">
        Browse the full{" "}
        <Link to="/collections/$slug" params={{ slug: "pcos-nutrition" }} className="text-brand underline">
          PCOS nutrition collection
        </Link>
        .
      </p>
    </section>
  );
}
